import React, { createContext, useContext, useState, useEffect } from 'react';
import TransactionsService from '../transactions.service';

const TransactionsServiceContext = createContext();

export const TransactionsServiceProvider = ({ children }) => {
  return (
    <TransactionsServiceContext.Provider value={TransactionsService}>
      {children}
    </TransactionsServiceContext.Provider>
  );
};

export const useTransactionsService = () => {
  const context = useContext(TransactionsServiceContext);
  if (context === undefined) {
    throw new Error('useTransactionsService must be used within a TransactionsServiceProvider');
  }
  return context;
};

export default TransactionsServiceContext;
